import React, { useState, useEffect } from 'react';
import { Upload, message } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const ImageUpload = ({ value, onChange, label }) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    // If value is a URL string (existing image), show it
    if (typeof value === 'string' && value) {
      setPreviewImage(value);
      setFile(null);
    }
    // If value is an object from VersatileImageField, extract URL
    else if (value && typeof value === 'object' && !(value instanceof File)) {
      const imageUrl = value.medium || value.large || value.full_size || value.thumbnail;
      if (imageUrl) {
        setPreviewImage(imageUrl);
        setFile(null);
      }
    }
    // If value is a File object (newly selected), create preview
    else if (value instanceof File) {
      const reader = new FileReader();
      reader.onload = (e) => setPreviewImage(e.target.result);
      reader.readAsDataURL(value);
      setFile(value);
    }
    // No value
    else {
      setPreviewImage(null);
      setFile(null);
    }
  }, [value]);

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('You can only upload image files!');
      return false;
    }

    const isLt5M = file.size <= MAX_FILE_SIZE;
    if (!isLt5M) {
      message.error('Image must be smaller than 5MB!');
      return false;
    }

    // Set file and create preview
    setFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setPreviewImage(e.target.result);
    reader.readAsDataURL(file);

    // Call onChange with the file
    if (onChange) {
      onChange(file);
    }

    // Prevent default upload behavior
    return false;
  };

  const handleRemove = () => {
    setPreviewImage(null);
    setFile(null);
    if (onChange) {
      onChange(null);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{label || 'Upload'}</div>
    </div>
  );

  return (
    <div style={{ position: 'relative' }}>
      <Upload
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        accept="image/*"
      >
        {previewImage ? (
          <img
            src={previewImage}
            alt="preview"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
      {previewImage && (
        <DeleteOutlined
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            fontSize: 18,
            color: '#ff4d4f',
            cursor: 'pointer',
            backgroundColor: 'white',
            borderRadius: '50%',
            padding: 4
          }}
          onClick={handleRemove}
        />
      )}
    </div>
  );
};

export default ImageUpload;
